import { ADMDocumentFormats, DMDocumentFormats } from "shared/constants";

const isEDDMFormat = (format: string) => {
  return Boolean(DMDocumentFormats[format as keyof typeof DMDocumentFormats]);
};

const isADMFormat = (format: string) => {
  return Boolean(ADMDocumentFormats[format as keyof typeof ADMDocumentFormats]);
};

/**
 * Map of USPS format names from backend to display format (smaller number first)
 * Backend sends: POSTCARD_9x6 -> Display shows: POSTCARD_6x9
 */
const USPS_FORMAT_DISPLAY_MAP: Record<string, string> = {
  POSTCARD_6x4: "POSTCARD_4x6",
  POSTCARD_9x6: "POSTCARD_6x9",
  POSTCARD_11x6: "POSTCARD_6x11",
  POSTCARD_15x12: "POSTCARD_12x15",
};

/**
 * Formats USPS format names for display (visual only, doesn't change the actual value)
 * @param format - The format string from backend (e.g., "POSTCARD_9x6")
 * @returns Formatted string for display (e.g., "POSTCARD_6x9")
 */
const formatUSPSFormatDisplay = (format: string): string => {
  return USPS_FORMAT_DISPLAY_MAP[format] || format;
};

export { isEDDMFormat, isADMFormat, formatUSPSFormatDisplay };
